import { useAuthenticatedUserSelector } from './useAuthenticatedUserSelector';

const MAX_ACCOUNTS = 21;

export const useCanCreateAccount = (): boolean => {
  const { user } = useAuthenticatedUserSelector();
  const totalAccounts = (user?.accounts.length || 0) + (user?.accountLinks?.length || 0);

  if (!user) {
    return false;
  }

  if (totalAccounts === MAX_ACCOUNTS) {
    return false;
  }

  return true;
};
